import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-position_arrow",
  "use": "icon-position_arrow-usage",
  "viewBox": "0 0 12 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 20\" id=\"icon-position_arrow\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-12-8h36v36h-36z\" /><path fill=\"#B3B3B3\" d=\"M7.758 10 .333 2.575 2.454.454 12 10l-9.546 9.546-2.121-2.121z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol